module.exports = __webpack_public_path__ + "img/2.a11312db.jpg";